import React, { useState } from 'react';
import parse from "html-react-parser"
import { formatDate } from '../utilities/utilities';

/*
function ProgramSchedule( props ) {
	return <>
		{ props.schedule && props.schedule.length > 0 && props.schedule.map( ( a, i ) => (

		<tr key={ a.hour + '-' + i } >
			<td style={{ fontSize:12, borderRight:'none', userSelect:'none', verticalAlign:'top' }} >
				{ a.hour }
			</td>
			<td colSpan={ 2 } style={{ borderLeft:'none' }} >
				<div style={{ fontSize:12, fontWeight:700 }} >{ parse( a.description || '' ) }</div>
				<div style={{ fontSize:12 }} >{ parse( a.notes || '' ) }</div>
			</td>
		</tr>
			
		) ) }
	</>
}
*/

function DaySchedule( props ) {
	return <>
		<tr>
			<td colSpan={ 3 } style={{ border:'none', fontSize:12 }} >
				{ parse( props.day_schedule || '' ) }
			</td>
		</tr>
	</>
}

function ProgramDay( props ) {
	const a = props.row
	const [ expand, setExpand ] = useState( props.index === 0 )
	return <>
		<tr 
			style={{ cursor:'pointer', userSelect:'none', }}
			onClick={ e => setExpand( !expand ) } 
		>

			{ a.day && 
			<td style={{ verticalAlign:'top' }} >
				<div style={{ fontSize:13, fontWeight:700, whiteSpace:'nowrap', }} >
					{ "Day " + ( props.index + 1 ) + " " }
				</div>
				<div style={{ fontSize:13, paddingTop:2, whiteSpace:'nowrap',  }} >
					{ formatDate( a.day ) }
				</div>
			</td>
			}

			<td style={{ borderRight:'none', width:'99%' }} >
				<div style={{ fontSize:13, fontWeight:700 }} >
					{ parse( a.title_day || '' ) }
				</div>
				{ a.title_night && 
					<div style={{ fontSize:13, paddingTop:2 }} >
						{ parse( a.title_night || '' ) }
					</div> }
			</td>
			<td style={{ borderLeft:'none', width:'1%', userSelect:'none' }} >
				<span className="material-symbols-outlined">
					{ expand ? 'keyboard_arrow_down' : 'chevron_right' }
				</span>
			</td>
		</tr>
		{/* expand && <ProgramSchedule schedule={ a.schedule } /> */}
		{ expand && <DaySchedule { ...a } /> }
	</>
}

export default function Program( props ) {

	const c = props.cruise

	//console.log( 'Program', props )

	if ( !c.program || c.program.length === 0 ) return false

	return <table><tbody style={{ fontSize:15 }} >
		{ c && c.program && c.program.map( ( a, i ) => <>
			<ProgramDay key={ a.day + i } row={ a } index={ i } />
		</> ) }
	</tbody></table>
}
